import React from "react";
import { useTranslation } from "react-i18next";
import "./SectionLoader.css";

function SectionLoader({ size = "md", label, className = "", compact = false }) {
  const { t } = useTranslation();

  return (
    <div
      className={`caf-section-loader caf-section-loader--${size}${
        compact ? " caf-section-loader--compact" : ""
      }${className ? ` ${className}` : ""}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label || t("Loading")}
    >
      <div className="caf-section-loader__inner">
        <div className="caf-section-loader__spinner" aria-hidden="true" />
        <p className="caf-section-loader__text">{label || t("Loading")}</p>
      </div>
    </div>
  );
}

export default SectionLoader;
